"use client"

import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { BlockRenderer, Container, ContentText, CustomBreadcrumbs, TopBanner } from "ui"
import { getBreadCrumbs } from "utils"
import { findProperty } from "utils/findProperty"
import Community from "./Community"

const StyledBreadCrumbsContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 80px;
    margin-bottom: 40px;
  }
`

type Props = {
  data: GetPageQuery
  locale: string
}

function EsgCommunity({ data, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    contentText: ContentText,
    community: Community,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )
  return (
    <>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
          }
        } else if (block.blockType === "numbersComponent1") {
          additionalProps = { accentColor: "black" }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          >
            {block.blockType === "topBanner" && (
              <Container>
                <StyledBreadCrumbsContainer>
                  <CustomBreadcrumbs current={selfObject} parents={parents} />
                </StyledBreadCrumbsContainer>
              </Container>
            )}
          </BlockRenderer>
        )
      })}
    </>
  )
}

export default EsgCommunity
